<template>
	<el-main class="bg-info-light">
		<div class="padding-20">
			<el-row :gutter="20">
				<el-col :span="12" class="margin-bottom">
					<el-card class="box-card" shadow="hover">
						<div slot="header" class="cl">
							<span style="line-height: 40px;">用户注册</span>
							<range-time class="y" v-model="user_total_time" style="width: 300px;" @change="userTimeChange"></range-time>
						</div>
						<div>
							<lee-bar-echarts
								ref="user"
								:grid-bottom="30"
								:height="'250px'"
								:show-legend="false"
								:show-left="true"
								:show-right="false"></lee-bar-echarts>
						</div>
					</el-card>
				</el-col>
				<el-col :span="12" class="margin-bottom">
					<el-card class="box-card" shadow="hover">
						<div slot="header" class="cl">
							<span style="line-height: 40px;">日活频次</span>
							<range-time class="y" v-model="login_total_time" style="width: 300px;" @change="loginTimeChange"></range-time>
						</div>
						<div>
							<lee-bar-echarts
								ref="login"
								:grid-bottom="30"
								:height="'250px'"
								:show-legend="false"
								:show-left="true"
								:show-right="false"></lee-bar-echarts>
						</div>
					</el-card>
				</el-col>
				<el-col :span="12" class="margin-bottom">
					<el-card class="box-card" shadow="hover">
						<div slot="header" class="cl">
							<span style="line-height: 40px;">企业发标数量</span>
							<range-time class="y" v-model="bids_total_time" style="width: 300px;" @change="bidsTimeChange"></range-time>
						</div>
						<div>
							<lee-bar-echarts
								ref="user_bids"
								:grid-bottom="30"
								:height="'250px'"
								:show-legend="false"
								:show-left="true"
								:show-right="false"></lee-bar-echarts>
						</div>
					</el-card>
				</el-col>
				<el-col :span="12" class="margin-bottom">
					<el-card class="box-card" shadow="hover">
						<div slot="header" class="cl">
							<span style="line-height: 40px;">平台发标数量</span>
							<range-time class="y" v-model="system_bids_total_time" style="width: 300px;" @change="SystembidsTimeChange"></range-time>
						</div>
						<div>
							<lee-bar-echarts
								ref="system_bids"
								:grid-bottom="30"
								:height="'250px'"
								:show-legend="false"
								:show-left="true"
								:show-right="false"></lee-bar-echarts>
						</div>
					</el-card>
				</el-col>
				<el-col :span="12" class="margin-bottom">
					<el-card class="box-card" shadow="hover">
						<div slot="header" class="cl">
							<span style="line-height: 40px;">热词搜索排行</span>
						</div>
						<div>
							<lee-bar-echarts
								ref="hot_words"
								:grid-bottom="30"
								:height="'250px'"
								:show-legend="false"
								:show-left="true"
								:show-right="false"></lee-bar-echarts>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>
	</el-main>
</template>

<script>
export default {
	name: "index",
	data() {
		return {
			user_total_time:'',
			bids_total_time:'',
			system_bids_total_time:'',
			login_total_time:'',
		}
	},
	created() {
		let _start_time = this.$moment().startOf('week').format('YYYY-MM-DD'); //本周一
		let _end_time = this.$moment().endOf('week').format('YYYY-MM-DD'); //本周日
		
		this.user_total_time = _start_time+','+ _end_time;
		this.bids_total_time = _start_time+','+ _end_time;
		this.system_bids_total_time = _start_time+','+ _end_time;
		this.login_total_time = _start_time+','+ _end_time;
	},
	mounted() {
		this.getTotal('user','注册人数');
		this.getTotal('user_bids','企业发标数量');
		this.getTotal('system_bids','平台发标数量');
		this.getTotal('login','登录');
		this.getHotWordsTotal();
	},
	methods: {
		loginTimeChange(e){
			this.getTotal('login','登录人数',e);
		},
		userTimeChange(e){
			this.getTotal('user','注册人数',e);
		},
		bidsTimeChange(e){
			this.getTotal('user_bids','企业发标数量',e);
		},
		SystembidsTimeChange(e){
			this.getTotal('system_bids','平台发标数量',e);
		},
		getTotal(type,title,time = null){
			console.log(type);
			let _this = this;
			_this.$http.httpPost({
				url: '/SystemTotal/listAll',
				datas: {type:type,total_time:time ? time : this.user_total_time,orderBy:'total_time',sortBy:'asc'},
				success: (res) => {
					let _bar1 = {bar:[],xaxis:[]};
					
					for (let i=0;i < res.length;i++) {
						_bar1.bar.push(res[i].count);
						
						let _time = _this.$moment.unix(res[i].total_time).format('YYYY-M-D')
						_bar1.xaxis.push(_time);
					}
					
					let _dw = '';
					
					if(type === 'login'){
						_dw = '次';
					}else if(type === 'user_bids'){
						_dw = '条';
					}else if(type === 'system_bids'){
						_dw = '条';
					}else if(type === 'user'){
						_dw = '家';
					}
					
					if(_this.$refs[type]) {
						_this.$refs[type].initData(
							[
								{name: title, type: 'bar', color: 'blue', data: _bar1.bar,dw:_dw},
							],
							_bar1.xaxis
						);
					}
				}
			});
		},
		getHotWordsTotal(){
			let _this = this;
			_this.$http.httpPost({
				url: '/HotWords/listAll',
				datas: {orderBy:'count',sortBy:'desc',limit:10},
				success: (res) => {
					let _bar1 = {bar:[],xaxis:[]};
					
					for (let i=0;i < res.length;i++) {
						_bar1.bar.push(res[i].count);
						
						_bar1.xaxis.push(res[i].title);
					}
					
					if(_this.$refs['hot_words']) {
						_this.$refs['hot_words'].initData(
							[
								{name: '热词', type: 'bar', color: 'blue', data: _bar1.bar,dw:'次'},
							],
							_bar1.xaxis
						);
					}
				}
			});
		}
	}
}
</script>
